import { useCallback, useEffect } from 'react';

import { walletActions, WalletTypes, useStore } from '@modules';

import useInterval from './useInterval';

const useUpdateWalletLimits = (
  params: WalletTypes.GETWalletLimitsParams & { shouldStop?: boolean }
): void => {
  const { crypto_currency, currency, type } = params;
  const [{ wallet }, dispatch] = useStore();
  const isLoading = !!wallet.loaders.getWalletLimits || !!wallet.loaders.getWalletLimitsPolling;

  const getLimits = useCallback(data => {
    dispatch(walletActions.getWalletLimitsPolling(data));
  }, []);

  useEffect(() => {
    if (
      crypto_currency &&
      currency &&
      type &&
      (!params.shouldStop || wallet.loaders.getWalletLimits === undefined)
    ) {
      getLimits({ crypto_currency, currency, type });
    }
  }, [crypto_currency, currency, type]);

  useInterval({
    callback: () => getLimits(params),
    delay: CONST.getLimitsInterval,
    shouldStop: isLoading || !!params.shouldStop,
  });
};

export default useUpdateWalletLimits;
